@switch (elementType()) {
	@case (TopSearchFilterElType.BTN) {
		<div class="flex flex-col items-start gap-1">
			<span
				class="hidden md:block text-sm md:text-xs font-semibold leading-tight text-white md:text-mainColor md:opacity-60"
			>
				{{ filter().text }}
			</span>
			<button
				class="w-full min-h-12 md:min-h-0 flex items-center justify-between px-3 py-2.5 md:py-2 transition text-mainColor text-xs md:text-base font-bold rounded-xl border-0 bg-white hover:bg-mainColorLight md:bg-mainColorHoverBg md:hover:bg-mainColorLight focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1"
				style="--tw-ring-color: var(--main-color-shadow)"
			>
				<span class="flex items-center gap-2 min-w-0">
					<i
						class="text-base md:text-sm text-mainColor {{ filter().iconClass || 'fa-solid fa-filter' }}"
						aria-hidden="true"
					></i>
					@if (selected$ | async; as selected) {
						<span
							class="text-sm md:text-base font-bold text-mainColor leading-tight max-w-full overflow-hidden text-ellipsis whitespace-nowrap"
						>
							{{ selected }}
						</span>
					} @else {
						<span
							class="text-sm md:text-base font-bold leading-tight max-w-full overflow-hidden text-ellipsis whitespace-nowrap"
							style="color: var(--main-color-hover-85); opacity: 0.75"
						>
							{{ getDefaultValueLabel(filter().id) }}
						</span>
					}
				</span>
				<i
					class="fa-solid fa-chevron-down text-sm md:text-xs ms-2 opacity-75"
					style="color: var(--main-color-hover-85)"
					aria-hidden="true"
				></i>
			</button>
		</div>
	}
	@case (TopSearchFilterElType.INPUT) {
		<div
			class="w-full min-h-12 md:min-h-0 flex items-center justify-between px-3 py-2.5 md:py-2 transition text-mainColor text-xs md:text-base font-bold rounded-xl border-0 bg-white hover:bg-mainColorLight md:bg-mainColorHoverBg md:hover:bg-mainColorLight relative focus-within:ring-2 focus-within:ring-offset-1"
			style="--tw-ring-color: var(--main-color-shadow)"
		>
			<input
				class="w-full bg-transparent text-center focus-visible:outline-0 focus:outline-0"
				placeholder="{{ filter().text }}"
				type="text"
				[formControl]="term"
			/>
			<i class="absolute top-1/2 -translate-y-1/2 left-2.5 text-mainColor fa-solid fa-magnifying-glass"></i>
		</div>
	}
}

<ng-content select="[dropdown]"></ng-content>
